import Swiper from "swiper/swiper-bundle";

function buildingSlider() {
  const isPresent = document.querySelector(".building-slider");
  if (!isPresent) {
    return;
  }

  const slider = new Swiper(".building-slider", {
    loop: true,
    autoplay: {
      delay: 5000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    slidesPerGroup: 1,
    keyboard: {
      enabled: true,
    },
    autoHeight: true,
    navigation: {
      nextEl: ".building-slider-next",
      prevEl: ".building-slider-prev",
    },
    pagination: {
      el: ".swiper-pagination--building",
      type: "bullets",
      clickable: true,
    },
  });
}

export { buildingSlider };
